import { ReactComponent as SearchLicenceIconSvg } from "./icon_search-licence.svg";

const SearchLicenceIcon = (props) => {
  return <SearchLicenceIconSvg {...props} />;
};

export default SearchLicenceIcon;
